import { HOME_TITLE } from "environment";

const enUS = {
  "period:to": "to",
  "period:calc": "calculating ...",
  "period:baseDate": "Base date",

  "common:remove": "Delete",
  "common:return": "Return",
  "common:asset": "Asset",

  "chart:resetZoom": "Reset zoom",
  "chart:desktop:zoom": "Click and drag in the chart area to zoom in",
  "chart:mobile:zoom": "Use 2 fingers to zoom",
  "chart:downloadPDF": "Download PDF",
  "chart:downloadPNG": "Download PNG",
  "chart:downloadJPEG": "Download JPEG",

  "molecules:TitleHome:Title:title-1":
    HOME_TITLE || "Comparador de ativos OUI Investimentos,",
  "molecules:TitleHome:Title:title-2": "mais que fundos de investimentos",
  "molecules:ConfigurationHeader:benchmark": "Benchmarks",
  "molecules:ConfigurationHeader:periodo": "Range",
  "molecules:ConfigurationHeader:aplicaoInicial": "Initial Application",
  "molecules:ActiveBox:cancelar": "Cancel",
  "molecules:ActiveBox:selecionar": "Select",
  "molecules:Modals:SerieModal:alert":
    "Alguns ativos não serão exibidos no gráfico pois não possuem série histórica em todo esse período.",
  "molecules:Modals:MobileFooter:close": "Close",
  "molecules:Modals:MobileFooter:shareLinkMessage": "Sharable Link:",
  "molecules:Modals:MobileFooter:shareQRTitle": "QR Code",
  "molecules:Modals:MobileFooter:shareQRCodeMessage":
    "Open your Camera app and point your phone at the QR code.",
  "molecules:Modals:MobileFooter:copy": "Copy",
  "molecules:Modals:MobileFooter:copyed": "Copyed!",
  "molecules:Card:asset": "Ativo",

  "organisms:SearchAssets:searchString":
    "Start typing to search for assets (name, ISIN or ticker)",
  "organisms:SelectedActives:title": "Selected assets",
  "organisms:SearchAssets:cnpj": "CNPJ",
  "organisms:SearchAssets:isin": "ISIN",
  "organisms:SearchAssets:managementCompany": "Management Company",
  "organisms:SearchAssets:type": "Type",
  "organisms:SearchAssets:situation": "Situation",
  "organisms:SearchAssets:stockExchange": "Stock Exchange",
  "organisms:SearchAssets:nenhumResultadoEncontrado":
    "Your search did not match any asset",
  "organisms:SearchHeader:viewSelectedAssets": "View selected assets",
  "organisms:OverlayRow:remover": "Delete",

  "pages:HomePage:ClearActives": "Clear",
  "pages:HomePage:AnalysisButton": "Iniciar análise dos ativos selecionados ",
  "pages:HomePage:AnalysisButton:mobile": "Iniciar análise dos ativos",
  "table:Header:Indicators": "Indicadores no período selecionado",
  "table:Header:ReturnHistory": "Histórico de Retorno",

  "tabs:Rentability": "Rentability",
  "tabs:Return": "Return",
  "tabs:Underwater": "Underwater",
  "tabs:Correlation": "Correlation",

  "share:shareLink": "Share Link",
  "share:QRCode": "Generate QR Code",
  "share:copyLink": "Copy Link",
  "share:copiedLink": "Copied Link!",
  "share:invalidLink": "Invalid Link!",
  "share:loadingLink": "Link is loading... please wait.",

  "month:0": "Jan",
  "month:1": "Fev",
  "month:2": "Mar",
  "month:3": "Abr",
  "month:4": "Mai",
  "month:5": "Jun",
  "month:6": "Jul",
  "month:7": "Ago",
  "month:8": "Set",
  "month:9": "Out",
  "month:10": "Nov",
  "month:11": "Dec",

  "shortMonth:0": "Jan",
  "shortMonth:1": "Feb",
  "shortMonth:2": "Mar",
  "shortMonth:3": "Apr",
  "shortMonth:4": "May",
  "shortMonth:5": "Jun",
  "shortMonth:6": "Jul",
  "shortMonth:7": "Aug",
  "shortMonth:8": "Sep",
  "shortMonth:9": "Oct",
  "shortMonth:10": "Nov",
  "shortMonth:11": "Dec",

  "period:NO_MES": "Month",
  "period:UM_ANO_UTIL": "1 year",
  "period:SEIS_MESES_UTEIS": "6 months",
  "period:CINCO_ANOS_UTEIS": "5 years",
  "period:OTIMO": "Optimal",

  "measure:RENTABILIDADE": "Rentability",
  "measure:PATRIMONIO_LIQUIDO": "P/E Millions",
  "measure:SHARPE": "Sharpe",
  "measure:TAXA_DE_ADMINISTRACAO": "Admin fee",
  "measure:VOLATILIDADE": "Volatility",
  "measure:RETORNO": "Return",
  "measure:RETORNO_UM_ANO": "Return 1 year",
  "measure:RETORNO_YTD": "YTD Return",
  "measure:DRAW_DOWN": "Drawdown",
  "measure:INICIO_DO_1_DRAW_DOWN": "Start of Maximum Drawdown",
  "measure:DATA_DO_1_DRAW_DOWN": "Maximum Drawdown Date",
  "measure:PRIMEIRO_DRAW_DOWN": "Maximum Drawdown",
  "measure:DRAW_DOWN:abv": "Drawdown",
  "measure:INICIO_DO_1_DRAW_DOWN:abv": "Max D.D. Start",
  "measure:DATA_DO_1_DRAW_DOWN:abv": "Max D.D. Date",
  "measure:PRIMEIRO_DRAW_DOWN:abv": "Max. D.D.",

  "assetType:FI": "FI",
  "assetType:FII": "FII",
  "assetType:EUROPA": "Europe",
  "assetType:ACAO": "Stocks",
  "assetType:RENDA_FIXA": "Fixed Income",
  "assetType:EMPRESA_ABERTA": "Open Company",

  "assetCategory:FUNDO": "Funds",
  "assetCategory:ACAO": "Stocks",
  "assetCategory:RENDA_FIXA": "Fixed Income",
  "assetCategory:PREVIDENCIA": "Pension",
  "assetCategory:EUROPA": "Europe",

  "chart:Rentability:title": "Rentability Chart",
  "chart:Return:title": "Return Chart",
  "chart:Underwater:title": "Underwater Chart",
  "chart:Correlation:title": "Correlation Chart",
};

export default enUS;
